function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUeberlegeneHaftung = function SvgUeberlegeneHaftung(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 116.4 92.04"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m87.39 45.76 28.76-15.12L58.08 0 0 30.54l29.43 15.52-.42.22L.25 61.41l58.07 30.63L116.4 61.5 86.97 45.98zM6.95 30.55l.42-.22 50.7-26.67.12.06 51.01 26.9-.42.22-50.7 26.66-.12-.06zm102.5 30.95-.42.22-50.7 26.66-.12-.06L7.2 61.42l.42-.22L32.9 47.9l.12.06 25.05 13.21L83.49 47.8l.12.06 25.84 13.63Z",
    style: {
      fill: "currentColor"
    }
  }));
};
export default SvgUeberlegeneHaftung;